import React, { lazy, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { ThemeProvider } from './contexts/ThemeContext';
import { ToastProvider } from './contexts/ToastContext';
import { AuthProvider } from './contexts/AuthContext';
import { readClientLink, readTechLink } from './types';
import './index.css';

// The three routes serve very different people. Load only the app this URL
// needs instead of making every phone download the builder dashboard too.
const App = lazy(() => import('./App'));
const TechApp = lazy(() => import('./components/tech/TechApp'));
const ClientApp = lazy(() => import('./components/client/ClientApp'));

// A tech link is its own small app: no account, no profile watch, no shell.
// Decided once, from the path, before anything else mounts.
const techId = readTechLink();
const clientId = readClientLink();

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider>
      <ToastProvider>
        <Suspense fallback={(
          <div className="min-h-app grid place-items-center p-6 font-mono text-xs uppercase tracking-widest text-dim">
            Opening BlueTape…
          </div>
        )}>
          {techId ? (
            <TechApp techId={techId} />
          ) : clientId ? (
            <ClientApp clientId={clientId} />
          ) : (
            <AuthProvider>
              <App />
            </AuthProvider>
          )}
        </Suspense>
        <div className="grain-overlay" aria-hidden="true" />
      </ToastProvider>
    </ThemeProvider>
  </React.StrictMode>,
);
